import { apiClient } from '@/shared/api/client'

export async function getSalesDashboard(params = {}) {
  const response = await apiClient.get('/sales/dashboard', { params })
  return response.data
}
